module.exports = __webpack_public_path__ + "static/media/logo-congemas.26cafb15.png";